import { render, staticRenderFns } from "./template_table.vue?vue&type=template&id=3feed833&scoped=true&"
import script from "./template_table.vue?vue&type=script&lang=js&"
export * from "./template_table.vue?vue&type=script&lang=js&"
import style0 from "./template_table.vue?vue&type=style&index=0&id=3feed833&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feed833",
  null
  
)

export default component.exports